var $ = require('jquery');

require('core-js');

$(document).ready(function () {
    if (typeof MktoForms2 !== "undefined") {
        MktoForms2.whenReady(function (form) {
            var urlParams = new URLSearchParams(window.location.search);
            var entries = urlParams.entries();
            var formVals = form.vals();

            var formId = "mktoForm_" + form.getId().toString()
            var formElement = document.getElementById(formId)
            formElement.style.fontFamily = "inherit";
            formElement.style.fontSize = "inherit";
            formElement.style.color = "inherit";

            for (var pair of entries) {
                for (var property in formVals) {
                    if (formVals.hasOwnProperty(property)) {
                        if (pair[0].toLowerCase() === property.toLowerCase()) {
                            formVals[property] = pair[1];
                        }
                    }
                }
            }

            if (formVals["uniquesubmitid"] !== "undefined" && formVals["uniquesubmitid"] == "") {
                formVals["uniquesubmitid"] = uuidv4();

                if (document.querySelector("[data-upload-platform]") && document.querySelector("[data-upload-platform]").dataset.uploadPlatform !== "undefined" && document.querySelector("[data-upload-platform]").dataset.uploadPlatform !== "") {
                    form.onSuccess(function () {
                        form.getFormElem().hide();
                        var isUniquePopulated = formVals["uniquesubmitid"] !== "undefined" && formVals["uniquesubmitid"] !== "";
                        var isDataFormLangPopulated = document.querySelector("[data-form-lang]") !== "undefined" && document.querySelector("[data-form-lang]") !== "";
                        var formId = form.getId();

                        if (isUniquePopulated && formId && isDataFormLangPopulated) {
                            getFormItem(document.querySelector("[data-upload-platform]").dataset.uploadPlatform, document.querySelector("[data-form-lang]").dataset.formLang, formId, formVals);
                        }

                        return false;
                    });
                }
            }

            form.setValues(formVals);

            // Captcha Submit tracking
            form.onValidate(function (isValid) {
                if (typeof (dataLayer) != 'undefined' && dataLayer != null) {
                    var mtCaptchaIsVisible = null;
                    var mtCaptchaIsVerified = null;

                    if (typeof (mtcaptcha) != 'undefined' && mtcaptcha != null && mtcaptcha.getStatus() != null) {
                        mtCaptchaIsVisible = mtcaptcha.getStatus().isVisible;
                        mtCaptchaIsVerified = mtcaptcha.getStatus().isVerified;
                    }

                    dataLayer.push({ 'event': 'wcmsFormSubmit', 'formIsValid': isValid, 'mtcaptchaIsVerified': mtCaptchaIsVerified, 'mtcaptchaIsVisible': mtCaptchaIsVisible });
                }
            });

            form.onSubmit(function () {
                //Check for API down

                var request = new XMLHttpRequest();
                request.open('GET', '/api/sitecore/MarketoFormModule/CheckServerStatus', true);

                request.onload = function () {
                    if (request.responseText === "false") {
                        form.submittable(false);
                        var vals = JSON.stringify(form.vals());

                        //Send email if server not responded.
                        var params = 'postedData=' + vals;
                        request.open('POST', '/api/sitecore/MarketoFormModule/SendMail');
                        request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                        request.send(params);
                        var errorMessage = $('input[name=error]').val();
                        form.showErrorMessage(errorMessage);
                    } else {
                        form.submittable(true);
                    }
                };
                request.send();
            });

            if (document.querySelector(".mtcaptcha")) {
                var recaptchaErrorEl = $('.recaptcha-error');

                form.submittable(false);

                //jQuery selector $('.[class-name]') was causing issues on IE
                document.querySelector(".mktoButtonRow").parentNode.insertBefore(document.querySelector(".mtcaptcha"), document.querySelector(".mktoButtonRow"));

                document.querySelector(".mktoButtonRow").parentNode.insertBefore(document.querySelector(".recaptcha-error"),
                    document.querySelector(".mktoButtonRow"));

                form.onValidate(function (builtInValidation) {
                    if (!builtInValidation) return;

                    //var recaptchaResponse = grecaptcha.getResponse();
                    let mtcaptchaToken = mtcaptcha.getVerifiedToken();
                    if (!mtcaptchaToken) {
                        recaptchaErrorEl.addClass('mktoInvalid');
                    } else {
                        recaptchaErrorEl.removeClass('mktoInvalid');
                        form.addHiddenFields({
                            lastRecaptchaUserInput: mtcaptchaToken
                        });

                        form.submittable(true);
                    }
                });
            }

            var marketoSelects = document.querySelectorAll('.marketo-form-container .form__marketo__wrapper select');

            if (marketoSelects.length != 0) {

                marketoSelects.forEach(function (item, i) {

                    item.parentElement.classList.add('mktoSelectField');

                    var selectArrow = document.createElement("span");
                    selectArrow.className = "mktoSelectArrow";

                    item.parentElement.insertBefore(selectArrow, item);
                    selectArrow.appendChild(item);
                });
            }
        });

        function uuidv4() {
            var crypto = window.crypto || window.msCrypto;
            return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        }

        function createMarketoUploadIframe(confirmation, url, id, formLang) {
            const confirmationBody = document.querySelector(confirmation);
            let uploadIframe = document.querySelector("file-upload-iframe");
            if ((uploadIframe == null || uploadIframe.length < 1) && confirmationBody) {
                let confirmationContentUrl = "/api/sitecore/marketoformmodule/GetConfirmationContent?id=" + id + "&lang=" + formLang;
                fetch(confirmationContentUrl)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error("Network response failed");
                        }
                        return response.json();
                        
                    })
                    .then(data => {
                        let formWrapper = document.querySelector(".form__marketo");

                        if (formWrapper.querySelector(".image-with-wrapped-content__title") && data["Confirmation Header"]) {
                            let formWrapperHeading = formWrapper.querySelector(".image-with-wrapped-content__title");
                            formWrapperHeading.innerHTML = unescape(data["Confirmation Header"]);
                        }

                        if (formWrapper.querySelector(".marketo-short-description") && data["Confirmation Short Description"]) {
                            let formShortDescription = formWrapper.querySelector(".marketo-short-description");
                            formShortDescription.innerHTML = unescape(data["Confirmation Short Description"]);
                        }

                        if (confirmationBody.querySelector("div") && confirmationBody.querySelector("div").childElementCount == 1) {
                            let confirmationHeadingWrapper = confirmationBody.querySelector("div");

                            if (confirmationHeadingWrapper && data["Confirmation Form Intro Title"]) {
                                confirmationHeadingWrapper.children[0].innerHTML = unescape(data["Confirmation Form Intro Title"]);
                            }

                            if (confirmationHeadingWrapper && data["Confirmation Form Intro Body"]) {
                                let confirmationHeadingWrapperContent = document.createElement("div");
                                confirmationHeadingWrapperContent.innerHTML = unescape(data["Confirmation Form Intro Body"]);
                                confirmationHeadingWrapper.after(confirmationHeadingWrapperContent);
                            }
                        }
                    })

                window.GenericUtilities.createFileUploadIframe(confirmationBody, url);
            }
        }

        function getFormItem(id, formLang, formId, formVals) {
            let apiUrl = "/api/sitecore/fileuploadplatform/getfileuploadconfiguration?id=" + id + "&lang=" + formLang;

            fetch(apiUrl)
                .then(response => {
                    if (!response.ok) {
                        throw new Error("Network response failed");
                    }
                    return response.json();
                })
                .then(data => {
                    if (data["Url"]) {
                        let iframeUrl = data["Url"] + "&form=" + formId + "&unique=" + formVals["uniquesubmitid"];
                        createMarketoUploadIframe(".form__marketo__wrapper", iframeUrl, id, formLang);
                    }
                    return data;
                    
                })
                .catch(error => {
                    console.log("Error:", error);
                })
        }
    }
});